import { NotificationDuration, NotificationStatus, NotificationVariant } from '@algoan/dashboard/model';
import { SuccessNotificationIcon } from './success-notification-icon';
import { ErrorNotificationIcon } from './error-notification-icon';

export const getDuration = (status: NotificationStatus): number => {
  switch (status) {
    case NotificationStatus.IDLE:
      return 0;
    case NotificationStatus.RENDERED:
      return NotificationDuration.RENDERED;
    case NotificationStatus.FADING:
      return NotificationDuration.FADING;
  }
};

export const getIcon = (variant: NotificationVariant | undefined): React.ReactNode => {
  switch (variant) {
    case NotificationVariant.SUCCESS:
      return <SuccessNotificationIcon />;
    case NotificationVariant.ERROR:
      return <ErrorNotificationIcon />;
  }
};
